import { TEMPLATE_TYPE } from './ChooseTemplateConstants';
export const UPDATE_BUFFER_DEBOUNCE_DELAY_MS = 500;
export const HEADER_BACKGROUND_IMAGE_STYLE = {
  STRETCH: 'STRETCH',
  TILE: 'TILE'
};
export const GRADIENT_TYPE = {
  DARK: 'DARK',
  LIGHT: 'LIGHT'
};
export const MAX_COUNT_OF_ARTICLES_ON_HOMEPAGE_CATEGORY = {
  [TEMPLATE_TYPE.DEFAULT]: 2,
  [TEMPLATE_TYPE.CONTENT]: 5
};
export const ERROR_TYPES = {
  FIELD_IS_REQUIRED: 'fieldIsRequired',
  INVALID_URL: 'invalidUrl'
};
export const CUSTOM_FIELD_TYPES = {
  COLOR_WITH_MOBILE_PREVIEW: 'color_with_mobile_preview',
  HEADER_BACKGROUND: 'headerBackground',
  HEADER_BACKGROUND_PREVIEW: 'header_background_preview',
  LOGO: 'logo',
  READONLY_INPUT: 'readOnlyInput',
  SOCIAL_ICON_STYLE: 'social_icon_shape_and_color',
  SOCIAL_LINKS: 'social_links',
  SUPPORT_FORM_ID: 'support_form_id',
  THEME_TYPE: 'theme_type'
};
export const NAV_ITEMS = {
  ARTICLE_PAGE: 'article-page',
  CATEGORY_PAGE: 'category-page',
  CATEGORY_ID: 'category-id',
  CATEGORIES: 'categories',
  CONTENT: 'content',
  EDIT_SOCIAL: 'edit-social',
  EDIT_FOOTER_LINKS: 'edit-footer-links',
  FOOTER: 'footer',
  GLOBAL_STYLES: 'global-styles',
  HOME_PAGE: 'home-page',
  HEADER: 'header',
  HEADER_BACKGROUND: 'header-background',
  NAV_BAR: 'nav-bar'
};
export let PREVIEW_PAGES;
(function (PREVIEW_PAGES) {
  PREVIEW_PAGES["ARTICLE_PAGE"] = "article-page";
  PREVIEW_PAGES["CATEGORY_PAGE"] = "category-page";
  PREVIEW_PAGES["HOME_PAGE"] = "home-page";
})(PREVIEW_PAGES || (PREVIEW_PAGES = {}));
export const NAV_ITEM_TO_PREVIEW_PAGE = {
  [NAV_ITEMS.ARTICLE_PAGE]: PREVIEW_PAGES.ARTICLE_PAGE,
  [NAV_ITEMS.CATEGORY_PAGE]: PREVIEW_PAGES.CATEGORY_PAGE,
  [NAV_ITEMS.CATEGORY_ID]: PREVIEW_PAGES.HOME_PAGE,
  [NAV_ITEMS.CATEGORIES]: PREVIEW_PAGES.HOME_PAGE,
  [NAV_ITEMS.HOME_PAGE]: PREVIEW_PAGES.HOME_PAGE,
  [NAV_ITEMS.HEADER]: PREVIEW_PAGES.HOME_PAGE,
  [NAV_ITEMS.HEADER_BACKGROUND]: PREVIEW_PAGES.HOME_PAGE
};
export const NAV_ITEMS_WITH_NO_BREADCRUMB = [NAV_ITEMS.ARTICLE_PAGE, NAV_ITEMS.CATEGORY_PAGE, NAV_ITEMS.HOME_PAGE];
export const NAV_ITEMS_WITH_DONE_LINK = [NAV_ITEMS.EDIT_SOCIAL, NAV_ITEMS.EDIT_FOOTER_LINKS, NAV_ITEMS.HEADER_BACKGROUND, NAV_ITEMS.CATEGORY_ID];
export const CONTENT_NAV_ITEMS_WITH_EDIT_FORM = [NAV_ITEMS.EDIT_SOCIAL, NAV_ITEMS.EDIT_FOOTER_LINKS, NAV_ITEMS.FOOTER, NAV_ITEMS.HEADER, NAV_ITEMS.HEADER_BACKGROUND, NAV_ITEMS.NAV_BAR];
export const TAB_IDS = {
  CONTENT: 'content',
  STYLES: 'styles'
};

// Key Paths
export const KNOWLEDGE_BASE_SETTINGS_KEY = 'knowledgeBaseSettings';
export const THEME_SETTINGS_KEY = 'themeSettings';
export const THEME_TYPE_SETTING_KEY_PATH = [THEME_SETTINGS_KEY, 'theme_type'];
export const LINKS_COLOR_SETTING_KEY_PATH = [THEME_SETTINGS_KEY, 'links_color'];
export const SUPPORT_FORM_ID_SETTING_KEY_PATH = [KNOWLEDGE_BASE_SETTINGS_KEY, 'supportFormId'];
export function getGradientSecondaryColor(gradientType, themeType) {
  if (gradientType === GRADIENT_TYPE.DARK) {
    return '#000000';
  }
  if (themeType === TEMPLATE_TYPE.TILES) {
    return '#F5F8FA';
  }
  return '#FFFFFF';
}
export function getLinearGradientStyle(gradientType, color) {
  return `linear-gradient(
    180deg,
    ${color} ${gradientType === GRADIENT_TYPE.DARK ? '25%' : '0%'},
    transparent ${gradientType === GRADIENT_TYPE.DARK ? '200%' : '97%'}
  )`;
}